<template>
  <div class="container">
    <div class="legend">
      <el-checkbox-group class="mobile_check" v-model="checkedLegends" @change="handleLegendChange">
        <template v-for="(item, index) in top16Legend">
          <el-checkbox :key="index" :label="item"> <span class="ric" :style="{ background: top16Colors[index] }"></span>{{ item }} </el-checkbox>
          <br :key="`br-${index}`" v-if="index > 0 && index % 4 === 0" />
        </template>
      </el-checkbox-group>
    </div>
    <div class="chart-scroll-container">
      <div ref="LineChartShort" class="LineChartShort"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LineChartShort",
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    alarmTotal: {
      type: Number,
      default: 0,
    },
    colorStops: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartInstance: null,
      rawLegendData: [
        "Human Experts",
        "Gemini-1.5-Pro-002",
        "GPT-4o",
        "Gemini-1.5-Flash-002",
        "Qwen-VL-Max",
        "Gemini-1.5-Flash-8B",
        "LongVU-7B",
        "E.T. Chat-3.8B",
        "LLaVA-Video-72B",
        "VILA1.5-40B",
        "MiniCPM v2.6-8B",
        "Oryx-34B",
        "VILA1.5-13B",
        "LongVA-7B",
        "LLaVA-Video-7B",
        "AoTD",
        "Video-RAG",
        "Moment-DETR",
        "UniVTG",
        "Time-R1-3B",
        "Time-R1-7B",
        "Qwen2.5-VL-7B",
        "Qwen2.5-VL-72B",
      ],
      rawSeriesData: [
        [93.62, 96.1, 95.31, 94.33, 95.39, 96.31, 93.98],
        [65.83, 78.22, 89.81, 74.85, 85.54, 92.85, 70.34],
        [64.07, 74.85, 88.56, 71.41, 81.18, 89.91, 67.74],
        [62.64, 73.73, 85.24, 72.1, 81.26, 90.15, 67.37],
        [54.46, 63.69, 82.77, 56.63, 64.8, 83.03, 55.55],
        [41.86, 50.85, 73.89, 55.7, 63.44, 82.38, 48.78],
        [15.37, 31.44, 63.06, 19.43, 34.18, 68.48, 17.4],
        [9.72, 21.54, 38.23, 14.94, 26.82, 45.56, 12.33],
        [8.88, 18.36, 40.4, 12.31, 22.08, 41.89, 10.6],
        [4.49, 10.88, 27.5, 6.82, 16.68, 40.84, 5.66],
        [4.49, 10.68, 36.94, 3.87, 12.61, 41.75, 4.18],
        [2.69, 8.88, 34.95, 5.39, 13.84, 41.4, 4.04],
        [0.8, 1.9, 4.72, 3.36, 6.21, 14.77, 2.08],
        [1.2, 4.49, 18.19, 2.54, 6.51, 21.87, 1.87],
        [1.1, 1.9, 11.27, 2.34, 4.07, 19.48, 1.72],
        [2.79, 5.29, 14.69, 3.36, 6.1, 11.95, 3.08],
        [0.3, 1.1, 7.52, 0.71, 1.83, 12.14, 0.51],
        [7.09, 17.17, 40.78, 10.38, 23.19, 51.2, 8.74],
        [13.0, 24.7, 53.16, 19.65, 34.42, 64.19, 16.33],
        [15.27, 32.53, 63.84, 22.38, 40.18, 72.85, 18.82],
        [22.36, 38.02, 68.25, 29.79, 44.86, 74.76, 26.03],
        [24.45, 32.63, 57.22, 29.7, 41.71, 65.62, 27.08],
        [28.04, 37.62, 61.01, 31.11, 43.13, 66.66, 29.69],
      ],

      rawColors: [
        "#FF5F5F",
        "#9E7CFF",
        "#40C4FF",
        "#69F0AE",
        "#FFF153",
        "#FF764B",
        "#EE88FF",
        "#279BCF",
        "#9CCC65",
        "#AEE5FF",
        "#FFA8B3",
        "#FFD700",
        "#FF69B4",
        "#8A2BE2",
        "#FF4500",
        "#2E8B57",
      ],
      checkedLegends: [],
    };
  },
  computed: {
    /* 1. 按 Avg 降序取前 16 个模型 */
    sortedTop16() {
      return this.rawSeriesData
        .map((d, idx) => ({ idx, avg: d[6] }))
        .sort((a, b) => b.avg - a.avg)
        .slice(0, 16);
    },
    /* 2. 仅 16 种颜色，且与排序后顺序一一对应 */
    top16Colors() {
      const base16 = this.rawColors.slice(0, 16);
      return this.sortedTop16.map((_, i) => base16[i]);
    },
    top16Legend() {
      return this.sortedTop16.map((item) => this.rawLegendData[item.idx]);
    },
    top16Series() {
      return this.sortedTop16.map((item) => this.rawSeriesData[item.idx]);
    },
    /* 3. 构造 modelColors 映射（排序后模型名 -> 上面 16 色） */
    modelColors() {
      const map = {};
      this.top16Legend.forEach((name, i) => {
        map[name] = this.top16Colors[i];
      });
      return map;
    },
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.updateChart();
        });
      },
    },
    // 监听窗口 resize，适配图表尺寸
    "$refs.LineChartShort.offsetWidth": {
      handler() {
        this.resizeChart();
      },
      immediate: false,
    },
  },
  mounted() {
    this.initChart();
    this.checkedLegends = [...this.top16Legend];
    this.updateChart();
    window.addEventListener("resize", this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },
  methods: {
    initChart() {
      this.chartInstance = this.$echarts.init(this.$refs.LineChartShort);
    },
    updateChart() {
      const option = this.chartOption();
      // 强制更新，避免缓存问题
      this.chartInstance.setOption(option, true);
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    chartOption() {
      const visibleSeries = this.top16Legend.reduce((acc, name) => {
        if (this.checkedLegends.includes(name)) {
          const dataIdx = this.top16Legend.indexOf(name);
          acc.push({
            name,
            type: "bar",
            data: this.top16Series[dataIdx],
            color: this.modelColors[name],
            barWidth: 6,
            barGap: 0.2,
          });
        }
        return acc;
      }, []);

      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          textStyle: {
            lineHeight: 18,
            fontSize: 12, // 适配小屏幕文字大小
          },
          confine: true, // 限制tooltip在图表内显示
          padding: 8, // 减少内边距，节省空间
        },
        legend: {
          show: false,
        },
        grid: {
          left: "10%",
          right: "3%",
          bottom: "50px", // 增加底部间距，避免x轴标签被遮挡
          top: "5%",
          containLabel: false,
        },
        xAxis: [
          {
            type: "category",
            data: [
              "Object Recall@1x, tIoU=0.7",
              "Object Recall@1x, tIoU=0.5",
              "Object Average mAP",
              "Scene Recall@1x, tIoU=0.7",
              "Scene Recall@1x, tIoU=0.5",
              "Scene Average mAP",
              "Avg Recall@1x, tIoU=0.7",
            ],
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#E0E0E0",
                fontSize: 11, // 适配小屏幕标签文字
              },
              interval: 0,
              rotate: 15, // 轻微旋转x轴标签，避免重叠
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "#E0E0E0",
                fontSize: 11, // 适配小屏幕数值文字
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#E0E0E0",
                width: 1,
                type: "solid",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#7A7A7A",
              },
            },
          },
        ],
        series: visibleSeries,
      };
    },
    handleLegendChange() {
      this.updateChart();
    },
  },
};
</script>

<style lang="scss" scoped>
// 仅保留平板和移动端断点
$tablet: 1024px; // 平板及以下（≤1024px）
$mobile: 768px; // 移动端及以下（≤768px）

.container {
  width: 100%;
  height: 100%;
  min-height: 500px; // 保证图表最小高度，避免空白
  display: flex;
  flex-direction: column;
  padding-top: 10px;
}

.legend {
  width: 100%;
  flex-shrink: 0;
  padding: 0 15px; // 增加左右内边距，避免选项贴边
  margin-bottom: 15px; // 图例与图表间距

  .ric {
    width: 12px;
    height: 12px;
    border-radius: 6px;
    margin-right: 4px;
    opacity: 0.6;
  }
}

.chart-scroll-container {
  flex: 1;
  width: 100%;
  overflow-x: auto; // 开启横向滚动
  overflow-y: hidden; // 隐藏纵向滚动
  -webkit-overflow-scrolling: touch; // 优化移动端滚动体验（平滑滚动）
  padding-bottom: 10px; // 预留滚动条空间，避免遮挡图表
}

.LineChartShort {
  flex: 1;
  width: 100%;
  min-height: 500px; // 图表最小高度，适配小屏幕
  min-width: 1000px;
}

// 复选框组基础样式
::v-deep {
  .el-checkbox-group.mobile_check {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 0; // 增加垂直间距，避免选项拥挤

    .el-checkbox {
      display: flex;
      align-items: center;
      width: 290px; // 默认宽度（桌面端）
      margin-right: 0;
      margin-bottom: 0;
      font-size: 14px; // 基础字体大小

      &.is-checked {
        .ric {
          opacity: 1;
        }
      }

      .el-checkbox__input {
        margin-top: 1px;
        margin-right: 6px; // 增加复选框与文字间距
      }

      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #ffffff;
        border-color: #ffffff;
      }

      .el-checkbox__inner {
        border: 1px solid #ffffff;
        background-color: transparent;
        width: 14px; // 适配小屏幕复选框大小
        height: 14px;
      }

      .el-checkbox__inner::after {
        box-sizing: content-box;
        content: "";
        border: 1px solid #000;
        border-left: 0;
        border-top: 0;
        height: 7px;
        left: 4px;
        position: absolute;
        top: 1px;
        transform: rotate(45deg) scaleY(0);
        width: 3px;
        transition: transform 0.15s ease-in 0.05s;
        transform-origin: center;
      }

      .el-checkbox__input.is-checked .el-checkbox__inner::after {
        transform: rotate(45deg) scaleY(1);
      }

      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #e0e0e0;
      }

      .el-checkbox__label {
        display: flex;
        align-items: center;
        color: #e0e0e0;
      }
    }
  }
}

// 平板适配（≤1024px）
@media (max-width: $tablet) {
  .legend {
    padding: 0 10px;
  }

  ::v-deep {
    .el-checkbox-group.mobile_check {
      .el-checkbox {
        width: 33%; // 平板端一行3个选项，优化横向布局
        font-size: 13px; // 缩小字体，节省空间
      }
    }
  }

  .LineChartShort {
    min-height: 500px; // 移动端图表高度适配
  }

  // 平板端x轴标签进一步旋转，避免重叠
  ::v-deep .ec-x-axis text {
    transform: rotate(20deg);
    text-anchor: start !important;
  }
}

// 移动端适配（≤768px）
@media (max-width: $mobile) {
  .container {
    min-height: 350px;
  }

  .legend {
    padding: 0 8px;
    margin-bottom: 10px;
  }

  ::v-deep {
    .el-checkbox-group.mobile_check {
      gap: 8px 0; // 减少垂直间距，节省空间

      .el-checkbox {
        width: 50%; // 移动端一行2个选项，适配小屏幕宽度
        font-size: 12px; // 进一步缩小字体
      }

      // 移动端复选框大小适配
      .el-checkbox__inner {
        width: 13px;
        height: 13px;
      }

      .el-checkbox__inner::after {
        height: 6px;
        width: 2.5px;
        left: 3.5px;
      }
    }
  }

  .LineChartShort {
    min-height: 500px; // 移动端图表高度适配
  }

  // 移动端x轴标签优化：旋转角度增大+文字更小
  ::v-deep .ec-x-axis text {
    font-size: 10px !important;
    transform: rotate(30deg);
    text-anchor: start !important;
  }

  // 移动端y轴数值文字更小
  ::v-deep .ec-y-axis text {
    font-size: 10px !important;
  }

  // 移动端tooltip文字适配
  ::v-deep .ec-tooltip {
    font-size: 11px !important;
  }
}
</style>
